export const GET_VENUES_WITHINRANGE= 'GET_VENUES_WITHINRANGE'
export const GET_VENUES_WITHINRANGE_SUCCESS= 'GET_VENUES_WITHINRANGE_SUCCESS'
export const GET_VENUES_WITHINRANGE_ERROR='GET_VENUES_WITHINRANGE_ERROR'

export const GetVenuesWithInRange= (data) => ({
    type: GET_VENUES_WITHINRANGE,
    payload: data
})


